import { FunctionDeclaration, Type } from "@google/genai";

export const altairDeclaration: FunctionDeclaration = {
  name: "render_altair",
  description: "Displays a data visualization graph using Altair. **Invocation Condition**: Call this tool when the user asks for a visual representation of data (e.g., 'Show me a graph of X'). Pass a valid JSON string of the Altair chart.",
  parameters: {
    type: Type.OBJECT,
    properties: {
      json_graph: {
        type: Type.STRING,
        description:
          "JSON STRING representation of the Altair graph to render. Must be a stringified JSON object.",
      },
    },
    required: ["json_graph"],
  },
};

export const AltairTools: FunctionDeclaration[] = [altairDeclaration];
